import { IDimension } from "../scroll/perfectScrollModel";
import { useCallback, MouseEvent } from "react";
import { setOffsetsOnScrollAction } from "../_features/setOffsetsOnScroll/setOffsetsOnScrollActions";
import {
    ICustomScrollSelector,
    ICustomScrollStore,
} from "../_store/CustomScrollStoreModel";
import { IThumbParams } from "../_shared/IThumbParams";
import { Func } from "../_utils/fnTypes";

/*
 */
const buildRailClickHandler = (
    k,
    selector: ICustomScrollSelector<IDimension>,
    args
) => (
    rail: HTMLDivElement,
    getC: Func<IThumbParams>,
    store: ICustomScrollStore
) =>
    useCallback(
        (e: MouseEvent<HTMLDivElement>) => {
            if (!rail) return;

            const positionMeasure =
                e[k.measure] -
                //@ts-ignore
                window[k.windowOffset] -
                rail.getBoundingClientRect()[k.railMeasure];

            const direction = positionMeasure > getC().thumbOffset ? 1 : -1;

            const { scrollMeasure, containerMeasure } = selector(
                store.getState()
            );

            store.dispatch(
                setOffsetsOnScrollAction.apply(
                    null,
                    args(scrollMeasure + direction * containerMeasure)
                )
            );
        },
        [rail]
    );

/*
 */
export const useHorizontalRailClickHandler = buildRailClickHandler(
    {
        measure: "pageX",
        windowOffset: "pageXOffset",
        railMeasure: "left",
    },
    x => x.horizontalDimension,
    x => [undefined, x]
);

/*
 */
export const useVerticalRailClickHandler = buildRailClickHandler(
    {
        measure: "pageY",
        windowOffset: "pageYOffset",
        railMeasure: "top",
    },
    x => x.verticalDimension,
    x => [x]
);
